import { useSupplierSettings } from './useSupplierSettings';

export function useInventoryManualUpdateByPopupAndFile() {
  const supplierSettings = useSupplierSettings();
  return Boolean(supplierSettings?.inventory_manual_update_ui_config?.allow_updates_via_popup_and_file_upload);
}
